<template>
  <HelloWorld msg="Welcome to Your Vue.js App"/>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'


export default {
  name: 'App',
  components: {
    HelloWorld
  }


}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.el-tabs__item {
  font-size: 20px; /* Change this value to adjust the font size */
}

/* Optionally, you can also modify the active tab font size */
.el-tabs__item.is-active {
  font-size: 20px; /* Adjust the active tab's font size */
}

.el-select {
  max-height: 400px; /* Adjust based on your needs */
  overflow-y: auto;
}
</style>
